export const runtimeRouteManifest = [
  { id: 'landing', path: '/', access: 'public', classification: 'product' },
  { id: 'privacy', path: '/privacy', access: 'public', classification: 'product' },
  { id: 'terms', path: '/terms', access: 'public', classification: 'product' },
  { id: 'docs', path: '/docs', access: 'public', classification: 'product' },
  { id: 'chat', path: '/chat/:conversationId?', access: 'owner', classification: 'product' },
  { id: 'claim-charts', path: '/claim-charts/*', access: 'owner', classification: 'product' },
  { id: 'tabular-reviews', path: '/tabular-reviews/*', access: 'owner', classification: 'product' },
  { id: 'workflows', path: '/workflows', access: 'owner', classification: 'product' },
  { id: 'research', path: '/research', access: 'owner', classification: 'product' },
  { id: 'document-editor', path: '/document-editor', access: 'owner', classification: 'product' },
  { id: 'matter-detail', path: '/matters/:matterId', access: 'owner', classification: 'product' },
  { id: 'account', path: '/account', access: 'authenticated', classification: 'product' },
  { id: 'auth', path: '/auth', access: 'public', classification: 'product' },
  { id: 'auth-callback', path: '/auth/callback', access: 'public', classification: 'product' },
  { id: 'ux-lab', path: '/dev/ux-lab', access: 'development', classification: 'development' },
  { id: 'word-addin-lab', path: '/dev/word-addin-lab', access: 'development', classification: 'development' },
  { id: 'not-found', path: '*', access: 'public', classification: 'system' },
] as const;

export type RuntimeRoute = (typeof runtimeRouteManifest)[number];
export type RouteId = RuntimeRoute['id'];
export type RouteAccess = RuntimeRoute['access'];

export function routeById(id: RouteId): RuntimeRoute {
  return runtimeRouteManifest.find((route) => route.id === id)!;
}
